
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import moment from 'moment';

import OrgSelect from '../../ui/OrgSelect';

const fields = [{
    "text": "活动部门",
    "field": "orgCode",
    org: true,
    rules: [
        { required: true, message: '活动部门不能为空!' },
    ]
}, {
    "text": "活动类型",
    "field": "type",
    rules: [
        { required: true, message: '活动类型不能为空!' },
        { max: 32, message: '活动类型不能超过32个字符！' },
    ]
}, {
    "text": "活动名称",
    "field": "name",
    rules: [
        { required: true, message: '活动名称不能为空!' },
        { max: 32, message: '活动名称不能超过32个字符！' },
    ]
}, {
    "text": "活动投放",
    "field": "launch",
    rules: [
        { max: 32, message: '活动投放不能超过32个字符！' },
    ]
}, {
    "text": "活动费用",
    "field": "fees",
    "number": true,
    rules: [
        { required: true, message: '活动费用不能为空!' },
    ]
}, {
    "text": "活动开始时间",
    "field": "startDate",
    "date": true,
    rules: [
        { required: true, message: '活动开始时间不能为空!' },
    ]
}, {
    "text": "活动结束时间",
    "field": "endDate",
    "date": true,
    rules: [
        { required: true, message: '活动结束时间不能为空!' },
    ]
}, {
    "text": "活动概述",
    "field": "summary",
    "textarea": true,
    rules: [
        { required: true, message: '活动概述不能为空!' },
        { max: 128, message: '活动概述不能超过128个字符！' },
    ]
}];


class MarketActivityEditForm extends Component {

    state = {}

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["startDate"] = values["startDate"].format("YYYY-MM-DD");
            values["endDate"] = values["endDate"].format("YYYY-MM-DD");
            http.post({
                url: '/marketActivity/saveActivity',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                : editData[item.field],
                        })(
                            item.org ? <OrgSelect treeDefaultExpandAll={true} />
                                : item.number ? <InputNumber precision={2} min={0.00} max={999999999} style={{ width: '100%' }} />
                                    : item.textarea ? <Input.TextArea rows={4} />
                                        : item.date ?
                                            <DatePicker style={{ width: '100%' }} />
                                            : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="市场活动信息维护"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const MarketActivityEdit = Form.create()(MarketActivityEditForm);

export default MarketActivityEdit;